"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _index = require("../../constants/index.js");
var _index2 = require("../../helpers/index.js");
var _index3 = require("../../utils/index.js");
var _excluded = ["accessMotion", "accessVoice", "accountRole", "addCoreProducts", "ban", "banCount", "banType", "billCycleEnd", "billCycleStart", "buildingType", "catalogueType", "channelOrgNumber", "channelOrgType", "channelOutletID", "checkoutType", "colophonID", "contentName", "dataRemaining", "dataTotal", "dataUsed", "daysRemaining", "dealerLegalName", "departmentName", "displayMode", "eKnowID", "email", "encryptedBan", "fmsid", "fontSize", "internalChannelOrgID", "internetType", "isLoggedIn", "isQualled", "knowledgeBaseArticleCategory", "knowledgeBaseArticleID", "knowledgeBaseArticleType", "lob", "loyaltyID", "loyaltyTier", "lpdsid", "ngcOrderID", "ngcOrderItemID", "ngcTransactionID", "offerType", "orderBasedDrop", "orderSubType", "orderType", "overageFlag", "pageBrand", "pageLanguage", "pageName", "pageProductCategory", "pageType", "personalizationId", "postalCode", "prodAvail", "prodElig", "prodOwned", "prospectID", "province", "rcid", "salesRepID", "siteGenerator", "ssmSessionID", "subCount", "subID", "subKey", "subscriberPhoneNumber", "subscriptionID", "tvType", "urlRedirect", "userAccountID", "userAccountType", "userLoginStatus", "userStatus", "userSystem", "wifiID", "wirelineAccounts"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var loginStatusTypes = _index.eventFieldValues.loginStatusTypes,
  qualledTypes = _index.eventFieldValues.qualledTypes;
var stringField = _index2.formatters.stringField,
  numberField = _index2.formatters.numberField,
  listField = _index2.formatters.listField,
  hashField = _index2.formatters.hashField;

// Keys that cannot be customized since they have a default value or works with a custom behavior
var lockedFields = ['adobeDataLayerBuilder', 'coreProducts', 'customPageViews', 'customSiteSection', 'dataLayerType', 'edgeServer', 'pageURL', 'previousPageType', 'primarySiteSection', 'qualledStatus', 'quaternarySiteSection', 'secondarySiteSection', 'tagManager', 'tertiarySiteSection', 'webApp'];
var getValues = function getValues(_ref) {
  var accessMotion = _ref.accessMotion,
    accessVoice = _ref.accessVoice,
    accountRole = _ref.accountRole,
    addCoreProducts = _ref.addCoreProducts,
    ban = _ref.ban,
    banCount = _ref.banCount,
    banType = _ref.banType,
    billCycleEnd = _ref.billCycleEnd,
    billCycleStart = _ref.billCycleStart,
    buildingType = _ref.buildingType,
    catalogueType = _ref.catalogueType,
    channelOrgNumber = _ref.channelOrgNumber,
    channelOrgType = _ref.channelOrgType,
    channelOutletID = _ref.channelOutletID,
    checkoutType = _ref.checkoutType,
    colophonID = _ref.colophonID,
    contentName = _ref.contentName,
    dataRemaining = _ref.dataRemaining,
    dataTotal = _ref.dataTotal,
    dataUsed = _ref.dataUsed,
    daysRemaining = _ref.daysRemaining,
    dealerLegalName = _ref.dealerLegalName,
    departmentName = _ref.departmentName,
    displayMode = _ref.displayMode,
    eKnowID = _ref.eKnowID,
    email = _ref.email,
    encryptedBan = _ref.encryptedBan,
    fmsid = _ref.fmsid,
    fontSize = _ref.fontSize,
    internalChannelOrgID = _ref.internalChannelOrgID,
    internetType = _ref.internetType,
    isLoggedIn = _ref.isLoggedIn,
    isQualled = _ref.isQualled,
    knowledgeBaseArticleCategory = _ref.knowledgeBaseArticleCategory,
    knowledgeBaseArticleID = _ref.knowledgeBaseArticleID,
    knowledgeBaseArticleType = _ref.knowledgeBaseArticleType,
    lob = _ref.lob,
    loyaltyID = _ref.loyaltyID,
    loyaltyTier = _ref.loyaltyTier,
    lpdsid = _ref.lpdsid,
    ngcOrderID = _ref.ngcOrderID,
    ngcOrderItemID = _ref.ngcOrderItemID,
    ngcTransactionID = _ref.ngcTransactionID,
    offerType = _ref.offerType,
    orderBasedDrop = _ref.orderBasedDrop,
    orderSubType = _ref.orderSubType,
    orderType = _ref.orderType,
    overageFlag = _ref.overageFlag,
    pageBrand = _ref.pageBrand,
    pageLanguage = _ref.pageLanguage,
    pageName = _ref.pageName,
    pageProductCategory = _ref.pageProductCategory,
    pageType = _ref.pageType,
    personalizationId = _ref.personalizationId,
    postalCode = _ref.postalCode,
    prodAvail = _ref.prodAvail,
    prodElig = _ref.prodElig,
    prodOwned = _ref.prodOwned,
    prospectID = _ref.prospectID,
    province = _ref.province,
    rcid = _ref.rcid,
    salesRepID = _ref.salesRepID,
    siteGenerator = _ref.siteGenerator,
    ssmSessionID = _ref.ssmSessionID,
    subCount = _ref.subCount,
    subID = _ref.subID,
    subKey = _ref.subKey,
    subscriberPhoneNumber = _ref.subscriberPhoneNumber,
    subscriptionID = _ref.subscriptionID,
    tvType = _ref.tvType,
    urlRedirect = _ref.urlRedirect,
    userAccountID = _ref.userAccountID,
    userAccountType = _ref.userAccountType,
    userLoginStatus = _ref.userLoginStatus,
    userStatus = _ref.userStatus,
    userSystem = _ref.userSystem,
    wifiID = _ref.wifiID,
    wirelineAccounts = _ref.wirelineAccounts,
    rest = _objectWithoutProperties(_ref, _excluded);
  var cleanedRest = (0, _index3.removeLockedKeys)(rest, lockedFields);
  var qualledStatus = isQualled ? qualledTypes.QUALLED : qualledTypes.GENERIC;
  var contentNameValue = stringField(contentName);
  var pageNameValues = pageName ? (0, _index2.getPageNameValues)(pageName, contentNameValue) : {};

  // TODO: remove userLoginStatusValue and use only loggedStatus when userLoginStatus field is deprecated
  var loggedStatus = isLoggedIn ? loginStatusTypes.LOGGED_IN : loginStatusTypes.NOT_LOGGED_IN;
  var userLoginStatusValue = stringField(userLoginStatus) || (typeof isLoggedIn === 'boolean' ? loggedStatus : undefined);

  // Remove warning when userLoginStatus field is deprecated
  if (userLoginStatus) {
    console.warn('alloyAnalytics: userLoginStatus field will be deprecated from pageLoaded event in a next major release, use isLogged field instead.');
  }
  // TODO ends

  return {
    name: pageNameValues.pageName,
    siteSection: pageNameValues.customSiteSection,
    _telus: _objectSpread({
      pageName: pageNameValues.pageName,
      customSiteSection: pageNameValues.customSiteSection,
      primarySiteSection: pageNameValues.primarySiteSection,
      secondarySiteSection: pageNameValues.secondarySiteSection,
      tertiarySiteSection: pageNameValues.tertiarySiteSection,
      quaternarySiteSection: pageNameValues.quaternarySiteSection,
      accessMotion: stringField(accessMotion),
      accessVoice: stringField(accessVoice),
      accountRole: stringField(accountRole),
      addCoreProducts: addCoreProducts,
      ban: ban,
      banCount: numberField(banCount),
      banType: listField(banType, {
        stringOptions: {
          toUpperCase: true,
          removeSpaces: true
        }
      }),
      billCycleEnd: billCycleEnd,
      billCycleStart: billCycleStart,
      buildingType: stringField(buildingType),
      catalogueType: stringField(catalogueType),
      channelOrgNumber: channelOrgNumber,
      channelOrgType: channelOrgType,
      channelOutletID: channelOutletID,
      checkoutType: stringField(checkoutType),
      colophonID: stringField(colophonID),
      contentName: contentNameValue,
      dataRemaining: dataRemaining,
      dataTotal: stringField(dataTotal),
      dataUsed: dataUsed,
      daysRemaining: daysRemaining,
      dealerLegalName: stringField(dealerLegalName),
      departmentName: stringField(departmentName),
      displayMode: stringField(displayMode),
      eKnowID: stringField(eKnowID),
      emailHash: hashField(email, {
        asEmail: true
      }),
      encryptedBan: stringField(encryptedBan),
      fmsid: fmsid,
      fontSize: fontSize,
      internalChannelOrgID: internalChannelOrgID,
      internetType: stringField(internetType),
      knowledgeBaseArticleCategory: stringField(knowledgeBaseArticleCategory),
      knowledgeBaseArticleID: stringField(knowledgeBaseArticleID),
      knowledgeBaseArticleType: stringField(knowledgeBaseArticleType),
      lob: stringField(lob),
      loyaltyID: stringField(loyaltyID),
      loyaltyTier: stringField(loyaltyTier),
      lpdsid: lpdsid,
      ngcOrderID: ngcOrderID,
      ngcOrderItemID: ngcOrderItemID,
      ngcTransactionID: ngcTransactionID,
      offerType: stringField(offerType),
      orderBasedDrop: stringField(orderBasedDrop),
      orderSubType: stringField(orderSubType),
      orderType: stringField(orderType),
      overageFlag: stringField(overageFlag),
      pageBrand: stringField(pageBrand),
      pageLanguage: stringField(pageLanguage),
      pageProductCategory: stringField(pageProductCategory),
      pageType: stringField(pageType),
      personalizationId: stringField(personalizationId),
      postalCodeHash: hashField(postalCode),
      prodAvail: stringField(prodAvail),
      prodElig: stringField(prodElig),
      prodOwned: listField(prodOwned, {
        separator: '|',
        shouldSort: true
      }),
      prospectID: stringField(prospectID),
      province: stringField(province),
      qualledStatus: typeof isQualled === 'boolean' ? qualledStatus : undefined,
      rcid: stringField(rcid),
      salesRepID: salesRepID,
      siteGenerator: siteGenerator,
      ssmSessionID: ssmSessionID,
      subCount: numberField(subCount),
      subId: subID,
      subKey: stringField(subKey),
      subscriberPhoneNumber: subscriberPhoneNumber,
      subscriptionID: stringField(subscriptionID),
      tvType: stringField(tvType),
      urlRedirect: urlRedirect,
      userAccountID: userAccountID,
      userAccountType: stringField(userAccountType),
      userLoginStatus: userLoginStatusValue,
      userStatus: stringField(userStatus),
      userSystem: stringField(userSystem),
      wifiID: stringField(wifiID),
      wirelineAccounts: wirelineAccounts === null || wirelineAccounts === void 0 ? void 0 : wirelineAccounts.toString()
    }, cleanedRest)
  };
};
var getTemplate = function getTemplate(_ref2) {
  var _window$__LOCALE__, _window$__LOCALE__2;
  var pageName = _ref2.pageName;
  var pageNameValues = !pageName ? (0, _index2.getPageNameValues)() : {};
  return {
    pageViews: {
      value: 1
    },
    name: pageNameValues.pageName,
    siteSection: pageNameValues.customSiteSection,
    server: document.location.origin,
    URL: document.location.href,
    _telus: {
      pageName: pageNameValues.pageName,
      customSiteSection: pageNameValues.customSiteSection,
      primarySiteSection: pageNameValues.primarySiteSection,
      secondarySiteSection: pageNameValues.secondarySiteSection,
      tertiarySiteSection: pageNameValues.tertiarySiteSection,
      quaternarySiteSection: pageNameValues.quaternarySiteSection,
      adobeDataLayerBuilder: 'alloyAnalytics',
      brand: (0, _index2.getBrandValue)({
        telus: 'telus',
        koodo: 'koodo'
      }),
      customPageViews: 1,
      dataLayerType: 'acdl',
      edgeServer: 'edge.adobedc.net',
      pageLanguage: stringField((_window$__LOCALE__ = window.__LOCALE__) === null || _window$__LOCALE__ === void 0 ? void 0 : _window$__LOCALE__.lang),
      pageURL: "".concat(document.location.origin).concat(document.location.pathname),
      // Avoid to include query params and hash fragments
      province: stringField((_window$__LOCALE__2 = window.__LOCALE__) === null || _window$__LOCALE__2 === void 0 ? void 0 : _window$__LOCALE__2.prov),
      site: (0, _index2.getBrandValue)({
        telus: 'telus.com',
        koodo: 'koodomobile.com',
        ngc: 'ngc'
      }),
      tagManager: 'adobe_launch',
      userAccountID: (0, _index2.getUserAccountID)(),
      webApp: 'web'
    }
  };
};
var getBaseTemplate = function getBaseTemplate(fields) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref3$inputOnly = _ref3.inputOnly,
    inputOnly = _ref3$inputOnly === void 0 ? false : _ref3$inputOnly;
  var values = getValues(fields);
  if (inputOnly) return values;
  var template = getTemplate(fields);
  return (0, _index3.mergeObjects)(values, template);
};
var _default = exports["default"] = getBaseTemplate;